import { render } from "./WalletPay.vue?vue&type=template&id=0217a0ac&scoped=true"
import script from "./WalletPay.vue?vue&type=script&lang=js"
export * from "./WalletPay.vue?vue&type=script&lang=js"

import "./WalletPay.vue?vue&type=style&index=0&id=0217a0ac&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0217a0ac"]])

export default __exports__